import axios, { AxiosInstance } from 'axios';

export const axiosAjax = (():AxiosInstance => axios.create({
    headers:{
        'Content-Type': 'application/json',
        'X-Requested-With':'XMLHttpRequest'
    },
    validateStatus: function (status) {
        return status >= 200 && status < 308;
    },
}))();

export * from 'axios';
